import { useCallback, useMemo, useState } from 'react'

export default function useDialogState<T extends Record<string, boolean>>(initialState: T) {
  const [dialogState, _setDialogState] = useState(initialState)

  const setDialogState = useCallback((key: keyof T, open: boolean) => {
    _setDialogState(prev => ({
      ...prev,
      [key]: open
    }))
  }, [])

  return useMemo(() => [dialogState, setDialogState] as const, [dialogState, setDialogState])
}
